import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyCbP_gR9tfk4WCEa_sMmKR0upsnRCzfWww",
    authDomain: "react-sample-dxc.firebaseapp.com",
    databaseURL: "https://react-sample-dxc.firebaseio.com",
    projectId: "react-sample-dxc",
    storageBucket: "react-sample-dxc.appspot.com",
    messagingSenderId: "264927863027",
    appId: "1:264927863027:web:7f1b380fd5d59b53da1786"
  };


const firebaseApp = firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();

export { auth };